export default __webpack_public_path__ + "static/media/blockchain_logo.e3060f1e.png";